import React from "react"
import { FieldLabel } from "../../../common/FieldLabel"
import { Link } from "@one-thd/sui-atomic-components";
import EmailEdit from "./EmailEdit";

export const EmailDisplay = (props) => {
  const { email, onEditEmail } = props;
  const emailAutomationId = "login-information--edit-email-link";

  return (
    <div className="col__12-12 u--paddingNone-horizontal">
      <div
        className="col__12-12 col__3-12--xs col__4-12--sm col__4-12--md col__4-12--lg u__bold u--paddingNone u--paddingSmall-right">
        <FieldLabel title="Email"/>
      </div>
      <div className="col__10-12 col__7-12--xs col__6-12--sm col__6-12--md col__6-12--lg u--paddingNone u__word_break">{email}</div>
      <div
        className="col__2-12 col__2-12--xs col__2-12--sm col__2-12--md col__2-12--lg u--paddingNone u__text-align--right">
        <button type="button" onClick={onEditEmail} data-automation-id={emailAutomationId}
                className="u--paddingSmall-left u__default-link">
          <Link>Edit</Link>
        </button>
      </div>
    </div>
  );
}

const EmailSection = (props) => {
  const {
    email,
    onEditEmail,
    isEditingEmail,
    onDoneEditing,
    onEmailChangeSuccess
  } = props;
  if (isEditingEmail) {
    return <EmailEdit onEmailChangeSuccess={onEmailChangeSuccess}
                      onDoneEditing={onDoneEditing} currentEmail={email}/>
  } else {
    return <EmailDisplay email={email} onEditEmail={onEditEmail}/>
  }
}

export default EmailSection
